export const AI_CONFIG = {
  NAME: 'Benjix',
  TITLE: 'Your Career Advisor',
  DESCRIPTION: 'I can help you find jobs or learn about Employers.io'
}
